
import React from 'react';
import NotFound from '../components/Common/NotFound';

const ErrorPage = () => {
  return (
    <NotFound />
  );
};

export default ErrorPage;
